module.exports = __webpack_public_path__ + "static/img/banner1.d86818f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/banner1.jpg
// module id = YtWb
// module chunks = 0